/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type Shot_status = "COMPLETED" | "FAILED" | "PENDING" | "PROCESSING" | "%future added value";
export type TourShotsGridGenerateStagedMutationVariables = {
    shotId: string;
    stagingPrompt: string;
};
export type TourShotsGridGenerateStagedMutationResponse = {
    readonly generateStagedShot: {
        readonly shot: {
            readonly id: string;
            readonly shotStatus: Shot_status;
            readonly stagedImageURI: string;
            readonly errorMessage: string;
        };
    };
};
export type TourShotsGridGenerateStagedMutation = {
    readonly response: TourShotsGridGenerateStagedMutationResponse;
    readonly variables: TourShotsGridGenerateStagedMutationVariables;
};



/*
mutation TourShotsGridGenerateStagedMutation(
  $shotId: ID!
  $stagingPrompt: String!
) {
  generateStagedShot(input: {shotId: $shotId, stagingPrompt: $stagingPrompt}) {
    shot {
      id
      shotStatus
      stagedImageURI
      errorMessage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shotId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stagingPrompt"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "shotId",
            "variableName": "shotId"
          },
          {
            "kind": "Variable",
            "name": "stagingPrompt",
            "variableName": "stagingPrompt"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "GenerateStagedShotPayload",
    "kind": "LinkedField",
    "name": "generateStagedShot",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Shot",
        "kind": "LinkedField",
        "name": "shot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shotStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stagedImageURI",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourShotsGridGenerateStagedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourShotsGridGenerateStagedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "003983a3c39a94650d67a85fb53d84f4",
    "id": null,
    "metadata": {},
    "name": "TourShotsGridGenerateStagedMutation",
    "operationKind": "mutation",
    "text": "mutation TourShotsGridGenerateStagedMutation(\n  $shotId: ID!\n  $stagingPrompt: String!\n) {\n  generateStagedShot(input: {shotId: $shotId, stagingPrompt: $stagingPrompt}) {\n    shot {\n      id\n      shotStatus\n      stagedImageURI\n      errorMessage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '5e082a86798ec31110be7a11c16661b8';
export default node;
